import React, { Component } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Event, ArrowBack } from '@mui/icons-material';

import { getAdvisor } from '../../services/vu'
import { getProperty } from '../../helpers/properties';
import parse from 'html-react-parser';
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse } }) => {
  return {
    locationCode: selectedCourse.locationCd
  }
}

class AccordionItem extends Component {
  constructor(props) {
    super(props)
  }

  setActive(bool) {
    if (this.props.active) {
      this.props.onItemActive(undefined)
    } else {
      this.props.onItemActive(this.props.number)
    }
  }

  render() {
    var data = this.props.data
    return (
      <div
        className={
          this.props.active ? 'accordion-item active' : 'accordion-item'
        }
      >
        <p className="title" onClick={this.setActive.bind(this)}>
          Q{this.props.number + 1}. {data.question}
        </p>
        <div className="description">{parse(data.answer)}</div>
      </div>
    )
  }
}

class SurveySubmit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      surveyId: getProperty("successSurveyTemplateId"),
      advisorInfo: undefined,
      pageReady: false,
      activeItem: 0
    }
  }

  componentDidMount = () => {
    getAdvisor(this.state.surveyId, this.props.locationCode).then(x => {
      this.setState({
        advisorInfo: x,
        pageReady: true
      })
    })
  }

  onItemActive(item) {
    this.setState({ activeItem: item })
  }

  render() {
    var self = this
    var advisorInfo = this.state.advisorInfo
    var advisorInfoPlan = this.state.advisorInfo
      ? this.state.advisorInfo.plan
      : undefined
    if (advisorInfoPlan) {
      var output = advisorInfoPlan.map((x, i) => {
        return (
          <AccordionItem
            data={x}
            key={i}
            number={i}
            onItemActive={self.onItemActive.bind(self)}
            active={i === self.state.activeItem}
          />
        )
      })
    }
    return (
      <div>
        <div className="survey-wrapper">
          <div className="survey-wrapper-sub">
            <div className="survey-header" id="survey-header">
              <NavLink className="survey-home-link" to={getConfiguration('baseUrl')}>
                <ArrowBack />
                <span className="logo">Logo</span>
              </NavLink>
            </div>
            {this.state.pageReady ? (
              <div>
                <div className="results-wrapper">
                  <div className="survey-completion-wrapper">
                    <div className="top-text">
                      <h1>SUCCESS PLAN COMPLETE</h1>
                      <h4>
                        Thank you for taking the time to complete the success
                        journey questions, your success plan can be found below.
                      </h4>
                    </div>
                    <div className="advisor-info">
                      <h4>
                        Your student advisor is {advisorInfo.advisor.Name}
                      </h4>
                      <div className="img-wrapper">
                        <img
                          src={advisorInfo.advisor.ImageUrl}
                          alt="advisor-image"
                        />
                      </div>
                      {parse(advisorInfo.advisor.Description)}
                    </div>
                  </div>
                  <div className="success-plan-wrapper">
                    <h4>Your success plan</h4>
                    {output}
                  </div>
                </div>
                <div className="appointment-wrapper">
                  <p>
                    Your Student Advisor will review your Success Plan over the
                    next few days and will contact you if they need to discuss
                    any elements of it. If you would like to discuss your
                    Success Plan with your Student Advisor, please make an
                    appointment.
                  </p>
                  <a
                    href={advisorInfo.advisor.bookAppointmentUrl}
                    className="btn btn-primary btn-lg appointment"
                  >
                    <Event /> Book an appointment
                  </a>
                </div>
              </div>
            ) : (
              <div className="survey-completion-wrapper">
                <div className="top-text">
                  <h1>SUCCESS PLAN LOADING...</h1>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(SurveySubmit))
